import { MenuPaymentSettingsBuilder } from "./menu.payment.builder";
import { MenuTipDollarSettings } from "./dollar-settings/menu.dollar.model";
import { MenuTipPercentageSettings } from "./percentage-settings/menu.percentage.model";
import { MenuDistributionSettings } from "./distribution-settings/menu.distribution.model";

export class MenuPaymentSettings {
  public readonly isFeeActive: boolean;
  public readonly isFeePercentage: boolean;
  public readonly isTippingActive: boolean;
  public readonly fee: number;
  public readonly isDistributeTippingActive: boolean;
  public readonly dollar: MenuTipDollarSettings;
  public readonly fiveToTen: MenuTipDollarSettings;
  public readonly percentage: MenuTipPercentageSettings;
  public readonly distribution: MenuDistributionSettings;
  constructor(builder: MenuPaymentSettingsBuilder) {
    this.isFeeActive = builder.isFeeActive;
    this.isFeePercentage = builder.isFeePercentage;
    this.isTippingActive = builder.isTippingActive;
    this.fee = builder.fee;
    this.isDistributeTippingActive = builder.isDistributeTippingActive;
    this.fiveToTen = new MenuTipDollarSettings(builder.fiveToTen);
    this.dollar = new MenuTipDollarSettings(builder.dollar);
    this.percentage = new MenuTipPercentageSettings(builder.percentage);
    this.distribution = new MenuDistributionSettings(builder.distribution);
  }
}
